import { type Common } from './common.js';
import { type EligiblePatient, type GetEligiblePatients } from './models/outreachPatients.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getEligiblePatients(args: GetEligiblePatients): Promise<EligiblePatient[]> {
    const url = this.common.constructPath('outreach-patients/eligible', args);
    const { eligiblePatients } = await this.common.getJSON(url);
    return eligiblePatients;
  }
}
